module.exports = __webpack_public_path__ + "img/ad.90753ee3.svg";